/** @jsx isolateComponent */
import React, { Fragment } from 'react';
import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/style-encapsulation';
import {
  Colors,
  Heading,
  HeadingLevel,
  Typography,
  TypographyName,
} from '@zapier/design-system';

import { SizeType } from '@zapier/product-get-help/src/types';

const headingCss = (size: SizeType, titleTypography?: TypographyName) => css`
  ${
    Typography[
      titleTypography
        ? titleTypography
        : size === 'small'
        ? 'pageHeader9'
        : 'pageHeader7'
    ]
  }
  color: ${Colors.neutral800};
`;

const childrenCss = () => css`
  ${Typography.paragraph3}
  color: ${Colors.neutral800};
`;

type SectionProps = {
  /** Title to display. */
  title: string;
  /** Optional title typography, which will override the default style */
  titleTypography?: TypographyName;
  /** Optional children to render one heading level lower. */
  children?: React.ReactNode;
  /** Size to display. */
  size?: SizeType;
};

/**
 * Renders a title, with optional children under the next heading level.
 */
const Section = ({
  children,
  title,
  titleTypography,
  size = 'large',
}: SectionProps) => {
  return (
    <Fragment>
      <Heading css={headingCss(size, titleTypography)}>{title}</Heading>
      {children && (
        <HeadingLevel>
          <div css={childrenCss()}>{children}</div>
        </HeadingLevel>
      )}
    </Fragment>
  );
};

export default Section;
